import React, { useEffect, useState } from 'react';
type Props = {
  setActiveFilter: (active: { id: string; name: string; subtext?: number }) => void;
  list: { id: string; name: string; subtext?: number }[];
};
const Tabs = ({ list, setActiveFilter }: Props) => {
  const [active, setActive] = useState(list?.[0]);
  useEffect(() => {
    setActiveFilter(active);
  }, [active]);
  return (
    <div className='w-full overflow-x-scroll flex gap-6 mb-4 pb-4 mt-2'>
      {list.map((item) => (
        <div
          className={`h-[37px] min-w-fit rounded-[20px] py-[6px] px-3 bg-gray-9 flex gap-2 items-center cursor-pointer ${
            active?.id === item.id && '!bg-gray-6'
          }`}
          key={item.id}
          onClick={() => {
            setActive(item);
          }}>
          <div
            className={`font-medium text-gray-5 text-base ${
              active?.id === item.id && 'text-white'
            }`}>
            {item.name}
          </div>
          {item.subtext && (
            <div
              className={`w-6 h-6 rounded-[20px] flex justify-center items-center bg-gray-2 text-xs text-gray-5  ${
                active?.id === item.id && 'text-white !bg-[#3D3D3D]'
              }`}>
              {item.subtext}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Tabs;
